import { Injectable } from '@angular/core';
import { StripeDeliveredMaterial } from './stripe-checkout.service';

export interface LastPurchase {
  orderId: string;
  email: string;
  completedAt: string;
  materials: StripeDeliveredMaterial[];
  manualUrl: string;
  groupUrl: string;
}

@Injectable({ providedIn: 'root' })
export class LastPurchaseService {
  private readonly storageKey = 'material_escolar_last_purchase';

  save(purchase: LastPurchase) {
    const materials = (purchase.materials || []).filter(
      material => !!material && !!material.name && !!material.url
    );
    if (!materials.length) {
      return;
    }
    localStorage.setItem(this.storageKey, JSON.stringify({ ...purchase, materials }));
  }

  get(): LastPurchase | null {
    try {
      const value = localStorage.getItem(this.storageKey);
      if (!value) {
        return null;
      }
      const purchase = JSON.parse(value) as LastPurchase;
      return purchase && Array.isArray(purchase.materials) && purchase.materials.length
        ? purchase
        : null;
    } catch {
      return null;
    }
  }

  exists(): boolean {
    return !!this.get();
  }
}
